import { EnvelopeSimple, InstagramLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { site } from "../content";

export const Footer = () => (
  <footer className="bg-[#2B2724] text-[#FBF8F4]/70 border-t border-[#FBF8F4]/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-3 md:items-center">
      <div>
        <img src="/images/logo-mark.png" alt="By Milja V -logo" className="w-14 h-14 rounded-full" loading="lazy" />
        <p className="mt-3 text-sm leading-relaxed max-w-xs" data-testid="footer-tagline">
          {site.footer.tagline}
        </p>
      </div>

      <div className="flex flex-col gap-3 text-sm">
        <a
          href={`mailto:${site.email}`}
          className="flex items-center gap-2.5 hover:text-[#FBF8F4] transition-colors duration-200 w-fit"
          data-testid="footer-email-link"
        >
          <EnvelopeSimple size={17} /> {site.email}
        </a>
        <a
          href={site.instagram.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2.5 hover:text-[#FBF8F4] transition-colors duration-200 w-fit"
          data-testid="footer-instagram-link"
        >
          <InstagramLogo size={17} /> {site.instagram.handle}
        </a>
      </div>

      <div className="flex flex-col gap-3 text-sm md:items-end">
        <Link
          to="/tietosuoja"
          className="hover:text-[#FBF8F4] transition-colors duration-200 w-fit"
          data-testid="footer-privacy-link"
        >
          {site.footer.privacy}
        </Link>
        <p data-testid="footer-copyright">{site.footer.copyright}</p>
        <p className="text-xs text-[#FBF8F4]/60" data-testid="footer-business-id">
          {site.footer.businessIdLabel} {site.businessId}
        </p>
        <p className="text-xs text-[#FBF8F4]/60" data-testid="footer-credit">
          {site.footer.creditLabel}{" "}
          <a
            href={site.footer.creditUrl}
            target="_blank"
            rel="noopener"
            className="hover:text-[#FBF8F4] transition-colors duration-200"
            data-testid="footer-credit-link"
          >
            {site.footer.creditName}
          </a>
        </p>
      </div>
    </div>
  </footer>
);
